export const buildings = {
    "your_buildings": "Tus edificios",
    "your_buildings_sub_title": "¡Tienes el control! Al seleccionar y hacer clic en un edificio, puedes realizar la facturación, controlar y hacer un seguimiento de los pagos.",
    "you_have_x_active_buildings": "Tienes {{number}} edificios activos",
    "building_x": "Edificio {{index}}",
    "building_address": "Dirección del edificio",
    "add_new_building": "Añadir nuevo edificio",
    "new_building_details": "Detalles del nuevo edificio",
    "enable_building_today": "¡Te permitirá cobrar tus facturas cooperativas hoy mismo!",
    "opening_building": " Abrir un edificio",
    "entrance_optional": "Entrada (opcional)",
    "building_manager_name": "Nombre del administrador del edificio",
    "adding_another_manager": "Agregar un administrador",
    "nav_bar_actions": "Acciones",
    "bank_account_owner": "Nombre del propietario de la cuenta bancaria",
    "bank_name": "Nombre del banco",
    "account_number": "Número de cuenta",
    "branch_number": "Número de sucursal",
    "terms_of_use": "Términos de uso",
    "cheque_photo": "Foto del cheque",
    "type_of_document": "Tipo de documento",
    "proof_of_ownership": "Comprobante de propiedad de la cuenta bancaria",
    "edit": "Editar",
    "legacyPayment": "Configuración manual",
    "total_payments_this_month": "Total de pagos realizados este mes",
    "total_payments_this_month_tooltip": "También incluye pagos de crédito y documentos de pago.",
    "hours_saved": "Tiempo que se ahorra por una transferencia manual",
    "hours_saved_tooltip": "Recuento de apartamentos pagados durante el trimestre actual multiplicado por 20 min.",
    "total_manual_deposit": "Total de pagos realizados mediante transferencia bancaria",
    "total_manual_deposit_tooltip": "Suma de pagos en efectivo y cheques del mes en curso",
    "total_debts_for_one_time": "Total de deuda de pagos únicos",
    "total_debts_for_one_time_tooltip": "Suma de todos los pagos únicos impagos de todos los apartamentos",
    "total_debts_for_monthly": "Total de deuda de pagos mensuales",
    "total_debts_for_monthly_tooltip": "Suma de deudas de pagos mensuales pasados y mes actual sobre todos los apartamentos",
    "no_payments_made_this_month_yet": "Todavía no se han realizado pagos este mes",
    "hours": "horas",
    "payment_by_methods_title": "Forma de pagos realizados",
    "connect_bank_account": "Conectar cuenta bancaria",
    "cheques": "Cheques",
    "notSet": "No determinado",
    "wires": "Transferencia bancaria",
    "bit": "bit",
    "creditCards": "Tarjeta de crédito",
    "creditCard": "Tarjeta de crédito",
    "applePay": "Apple pay",
    "onlineDirectWire": "Transferencia bancaria a través de Blink",
    "unknownPaymentMethod": "Desconocido",
    "tenantRecord": "Registro de inquilino",
    "tenantRecordList": "Lista de registros de inquilinos",
    "monthly_amount_passed_to_building_title": "Transferencia mensual de crédito de Bllink al edificio",
    "monthly_amount_hover_title": "Monto mensual",
    "monthly_amount_hover_title_admin": "Monto mensual (debe ser igual que en el informe mensual)",
    "nav_bar_edit_building": "Editar edificio",
    "nav_bar_edit_contacts": "Editar contactos",
    "nav_bar_edit_building_commission": "Editar edificio commission",
    "nav_bar_buildings_list": "Lista de edificios",
    "nav_bar_buildings_data": "Datos de los edificios",
    "nav_bar_all_buildings_data": "Todos los datos de los edificios",
    "nav_bar_main_screen": "Tablero del edificio",
    "nav_bar_tenant_list": "Lista de inquilinos",
    "nav_bar_archive": "Archivo",
    "nav_bar_maintenance": "Mantenimiento",
    "nav_bar_maintenance_management": "Manejo de mantenimiento",
    "nav_bar_maintenance_systems": "Sistemas",
    "nav_bar_maintenance_tenant_reports": "Mantenimiento",
    "nav_bar_maintenance_on_going": "preventive tasks",
    "nav_bar_maintenance_reports": "reports",
    "nav_bar_maintenance_documents": "Documentos",
    "nav_bar_maintenance_vendors": "Vendedores",
    "nav_bar_maintenance_permissions": "Permisos de mantenimiento",
    "nav_bar_reports": "Informes de los pagos",
    "nav_bar_reports_yearly_cashflow": "Flujo de caja anual",
    "nav_bar_reports_monthly_cashflow": "Mensual",
    "nav_bar_reports_apartment_cashflow": "Apartamento",
    "nav_bar_reports_apartment": "Informe del apartamento",
    "nav_bar_reports_yearly_by_months": "Anual",
    "nav_bar_reports_yearly_by_one_time": "Anual (una sola vez)",
    "nav_bar_reports_update_payment": "Registrar\/realizar un pago",
    "nav_bar_payments_rates": "Tasas de pago",
    "nav_bar_update_payments": "Actualizar cuotas mensuales",
    "nav_bar_record_an_expense": "Registrar un gasto",
    "nav_bar_expenses": "Gastos",
    "building_created_message": "Edificio creado con éxito. Volverás a la pantalla principal",
    "nav_bar_update_rates": "Actualizar tarifas",
    "must_upload_document": "Se requiere documento de prueba de propiedad",
    "nav_bar_update_payments_year": "Actualizar tarifas de pago {{year}}",
    "nav_bar_view_monthly": "Ver cuotas mensuales",
    "nav_bar_add_one_time": "Agregar nuevo pago único",
    "nav_bar_special_payments": "Pagos especiales",
    "nav_bar_reports_expenses": "Informe de gastos",
    "nav_bar_reports_monthly_expenses": "Gastos mensuales",
    "nav_bar_reports_expenses_balance": "Saldo de gastos",
    "nav_bar_bank_adjustment": "Ajustes bancarios",
    "nav_bar_bank_reconciliation": "conciliación bancaria",
    "nav_bar_debt_list": "Lista de deudas",
    "nav_bar_brochure": "Folleto del edificio",
    "nav_bar_rewards": "Recompensas",
    "nav_bar_refresh": "Actualizar datos del edificio",
    "nav_bar_update_payment_plans": "check payment plans amounts",
    "nav_bar_admin": "Menú de administración",
    "nav_bar_new_bank_adjustments": "Nuevos ajustes bancarios",
    "nav_bar_auto_campaign": "Campaña automática",
    "nav_bar_message_platform": "Plataforma de mensajes",
    "nav_bar_monitoring": "Vigilancia",
    "nav_bar_search_payments": "Buscar pagos",
    "nav_bar_set_broadcast": "Set broadcast",
    "nav_bar_products_at_a_discount": "Productos con descuento",
    "nav_bar_funds_early_transfer": "Retirar fondos a la cuenta",
    "address_pop_up": {
        "header": "Introducción manual de la dirección de un nuevo edificio",
        "edit_address": "Editar dirección (asegúrate de escribirla tal como aparece en Google Maps)",
        "labels": {
            "street_name": "Nombre de la calle (él)",
            "street_number": "Número de calle",
            "city": "Ciudad (él)",
            "country": "País (él)",
            "entrance": "Entrada (opcional)",
            "building_title": "Nombre del edificio",
            "nickname": "Apodo (en caso de que la dirección no aparezca en google/nombre especial para edificio)",
        },
        "update": "Actualizar"
    },
    "nav_bar_upload_payment": "Cargar el pago sin conexión",
    "collection_status_title": "Estado del cobro",
    "collection_status_uploaded": "Se cargó el estado del cobro",
    "something_wrong": "Ocurrió un error",
    "didntManagerToFindNewPrimary": "No logré encontrar un nuevo contacto principal. El apartamento se quedará sin {{typeOfTenant}} principal",
    "editBuildingTitle": "Editar dirección del edificio",
    "open_new_building": "Abrir una cuenta nueva",
    "autoCheque": "Cheque digital a través de un escáner de cheques",
    "nav_bar_update_one_time": "Actualizando",
    "document_too_large": "La imagen o el documento es demasiado grande. Seleccione un tamaño inferior a 2 MB",
    "add_bank_details_title": "¿A donde transferir el dinero?",
    "building_added": "El edificio se creó con éxito en el sistema de Bllink.",
    "actions_left": "Ahora solo te queda configurar la cuenta bancaria que sabremos donde transferir los pagos de los inquilinos",
    "proof_of_ownership_title": "La confirmación de la titularidad de la cuenta o la fotocopia de un cheque son necesarios para completar el proceso.",
    "no_entrance": "Sin entrada",
    "entrance": "Entrada",
    "collection_status_uploaded_in_background": "10 líneas y será enviado para actualización de fondo. Será posible comprobar el estado en un informe anual en aproximadamente 10 minutos",
    "cash": "Depósito en ventanilla",
    "bankCharge": "Cargo bancario",
    "confirm": "Confirmar",
    "full_address": "Dirección completa",
    "dashboard_title": "Análisis del tablero",
    "general_building_data": "Datos generales del edificio",
    "building_score": "Puntaje de construcción",
    "today_stats": "Estadísticas de hoy",
    "new_payments": "Nuevos pagos",
    "recurring_payments": "Pagos recurrentes",
    "last_actions": "Últimas acciones",
    "financial_data": "Datos financieros",
    "whatsapp": "WhatsApp",
    "ivr": "IVR",
    "incomes": "Ingresos",
    "expenses": "Gastos",
    "waiting": "Esperando",
    "to": "a",
    "from": "de",
    "payment_method_type": "Tipo de método de pago",
    "maintenance_manager_title": "POC LIVY manager side for ",
    "open_building": "Abrir un nuevo edificio",
    "withdrawal_now_description": "Para saber el saldo inmediato para retirar a la cuenta bancaria y hacer un adelanto de dinero",
    "withdrawal_now_phone_number": "Contáctenos 03-5090045"
};
